<template>
  <div id="cardApp" class="app-wrapper">
    <div class="main-wrapper">
      <main class="content-main">
        <img src="@/assets/banner.png" style="width:100%" />
        <img src="@/assets/hktcmbg.png" style="width:100%" />
        
        <div class="page-title-row" style="display: flex; justify-content: space-between; align-items: center;">
          <h3 style="margin: 0;">Credit Card Application</h3>
        </div>

        <div class="apply-section">
          <div class="apply-item">
            <div class="apply-info">
              <div class="apply-title">Existing Trust Client Application</div>
            </div>
            <!-- ✅ 移除 target="_blank"，当前窗口跳转 -->
            <a href="https://member.hongkongtrust.com.hk/#/login" class="apply-btn apply-btn-primary" style="text-decoration: none;">Apply Now</a>
          </div>
          <div class="apply-item">
            <div class="apply-info">
              <div class="apply-title">New User Application</div>
              <div class="apply-desc">Register as a new user to apply for a credit card</div>
            </div>
            <!-- ✅ 绑定点击事件 -->
            <button class="apply-btn apply-btn-secondary" @click="openNewUserDialog">Apply for New User</button>
          </div>
        </div>

        <div style="margin-top: 20px; padding: 15px; background: #f8f9fa; border-radius: 8px; font-size: 13px; color: #666;">
          Online applications are not processed immediately and should not be used for urgent submissions. For any inquiries, please contact us promptly via email.
        </div>
      </main>
    </div>

    <!-- ✅ 新用户申请弹窗 -->
    <div v-if="newUserDialogVisible" class="dialog-overlay" @click.self="closeNewUserDialog">
      <div class="dialog-container">
        <div class="dialog-header">
          <h3>New User Application</h3>
          <button class="dialog-close" @click="closeNewUserDialog">&times;</button>
        </div>
        <div class="dialog-body">
          <form @submit.prevent="submitNewUserForm">
            <div class="form-group">
              <label class="form-label" for="name">* Name</label>
              <input type="text" id="name" v-model="newUserForm.name" class="form-input" required placeholder="Please enter your name" />
            </div>
            <div class="form-group">
              <label class="form-label" for="phone">* Phone</label>
              <input type="tel" id="phone" v-model="newUserForm.phone" class="form-input" required placeholder="Please enter your phone number" />
            </div>
            <div class="form-group">
              <label class="form-label" for="email">* Email</label>
              <input type="email" id="email" v-model="newUserForm.email" class="form-input" required placeholder="Please enter your email address" />
            </div>
            <div class="form-group">
              <label class="form-label" for="message">Message</label>
              <textarea id="message" v-model="newUserForm.message" class="form-textarea" placeholder="Please enter your message"></textarea>
            </div>
            <div class="form-actions">
              <button type="button" class="btn btn-cancel" @click="closeNewUserDialog">Cancel</button>
              <button type="submit" class="btn btn-submit">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreditCardStatic',
  data() {
    return {
      // ✅ 弹窗控制状态
      newUserDialogVisible: false,
      // ✅ 表单数据
      newUserForm: {
        name: '',
        phone: '',
        email: '',
        message: ''
      }
    }
  },
  methods: {
    // ✅ 打开弹窗
    openNewUserDialog() {
      this.newUserDialogVisible = true
      // 重置表单（可选）
      this.newUserForm = {
        name: '',
        phone: '',
        email: '',
        message: ''
      }
    },
    // ✅ 关闭弹窗
    closeNewUserDialog() {
      this.newUserDialogVisible = false
    },
    // ✅ 提交表单
    submitNewUserForm() {
      // 简单校验
      if (!this.newUserForm.name || !this.newUserForm.phone || !this.newUserForm.email) {
        alert('Please fill in all required fields.')
        return
      }
      
      // ✅ 这里添加实际提交逻辑，例如 API 请求
      console.log('Submitting new user form:', this.newUserForm)
      
      // 模拟提交成功
      alert('Thank you! Your application has been submitted successfully.')
      
      // 关闭弹窗并重置
      this.closeNewUserDialog()
    }
  }
}
</script>

<style>
:root {
  --bg-light: #f8f9fc;
  --primary-color: #1E3A8A;
  --accent-color: #F59E0B;
  --border-color: #e2e8f0;
  --text-primary: #1E293B;
  --text-secondary: #64748B;
  --text-error: #EF4444;
  --bg-white: #fff;
  --bg-gray: #f8f9fa;
}

body, html { 
  margin: 0; padding: 0; height: 100%; 
  font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; 
  background-color: var(--bg-light); 
  overflow: hidden; 
}

.app-wrapper { display: flex; height: 100vh; }
.main-wrapper { flex: 1; display: flex; flex-direction: column; overflow: hidden; position: relative; }
.content-main { flex: 1; padding: 25px; overflow-y: auto; }

.apply-section { 
  background: white; 
  border-radius: 12px; 
  padding: 25px; 
  box-shadow: 0 2px 8px rgba(0,0,0,0.05); 
  margin-top: 20px; 
}

.apply-item { 
  display: flex; 
  justify-content: space-between; 
  align-items: center; 
  padding: 20px 0; 
  border-bottom: 1px solid #eee; 
}
.apply-item:last-child { border-bottom: none; }

.apply-info { flex: 1; text-align: left; }
.apply-title { font-weight: bold; font-size: 16px; color: #333; margin-bottom: 5px; }
.apply-desc { font-size: 14px; color: #666; }

.apply-btn { 
  min-width: 120px; 
  padding: 10px 20px; 
  border-radius: 8px; 
  font-weight: 500; 
  cursor: pointer; 
  text-align: center; 
  transition: all 0.3s ease; 
}

.apply-btn-primary { 
  background-color: var(--primary-color); 
  color: white; 
  border: 1px solid var(--primary-color); 
}
.apply-btn-primary:hover { background-color: #3B82F6; border-color: #3B82F6; }

.apply-btn-secondary { 
  background-color: white; 
  color: var(--primary-color); 
  border: 1px solid var(--primary-color); 
}
.apply-btn-secondary:hover { background-color: #eff6ff; }

/* 弹窗样式 */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.dialog-container {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from { 
    opacity: 0; 
    transform: translateY(20px); 
  }
  to { 
    opacity: 1; 
    transform: translateY(0); 
  }
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  background: var(--bg-gray);
  border-bottom: 1px solid var(--border-color);
}

.dialog-header h3 {
  margin: 0;
  color: var(--primary-color);
  font-size: 18px;
}

.dialog-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: var(--text-secondary);
  transition: color 0.2s;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.dialog-close:hover {
  color: var(--text-error);
  background: rgba(239, 68, 68, 0.1);
}

.dialog-body {
  padding: 25px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  text-align: left;
  margin-bottom: 8px;
  font-weight: 500;
  color: var(--text-primary);
}

.form-label .required {
  color: var(--text-error);
}

.form-input, .form-textarea {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-size: 14px;
  color: var(--text-primary);
  transition: all 0.3s;
  box-sizing: border-box;
}

.form-input:focus, .form-textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(30, 58, 138, 0.1);
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 25px;
}

.btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  border: none;
}

.btn-cancel {
  background: #f1f5f9;
  color: var(--text-primary);
}

.btn-cancel:hover {
  background: #e2e8f0;
}

.btn-submit {
  background: var(--primary-color);
  color: white;
}

.btn-submit:hover {
  background: #3B82F6;
}

@media (max-width: 768px) {
  .apply-item { flex-direction: column; align-items: flex-start; gap: 15px; }
  .dialog-container { width: 95%; }
}
</style>